import { useParams } from '@tanstack/react-router';

import { REFETCH_AGENT_RUN_INTERVAL } from '@/constants';

import { toAgentRunId, useGetAgentRun } from './api';

export const useGetAgentRunFromPath = () => {
  const { agentId, runId } = useParams({ strict: false });
  return useGetAgentRun(toAgentRunId(agentId, runId), {
    fetchFromListCache: true,
    refetchInterval: REFETCH_AGENT_RUN_INTERVAL,
  });
};
